<div class="container-fluid">
  <page-header-search [isSearchInput]="true" [pageTitleValue]="pageTitle" [placeholderValue]="placeholder"
    (onHeaderInputKeyup)="onSearchKeyup($event)" (onHeaderSearchSubmit)="onSearchSubmit($event)"></page-header-search>

  <div class="row" *ngIf="!patientList?.length">
    <div class="col-12 text-center py-5">
      Hmm, There is no data to show!
    </div>
  </div>
  <div class="card mt-5"  *ngIf="patientList.length">
    <div class="card-body">
      <div class="table-title">
        <h3 class="title mb-0">{{ tableTitle }}</h3>

      </div>
      <ngx-datatable class="material ngx-datatable-custom" [rows]="filteredPatientList"
        [limit]="pageSize" [offset]="currentPage-1" columnMode="force" externalPaging="true"
        [count]="totalItems" [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
        (page)="onChangePage($event)">
        <ngx-datatable-column name="Name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row.fullName}}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Phone Number">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row.phone}}</span>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Gender">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <span>{{row.gender}}</span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Card Status">
          <ng-template let-row="row" ngx-datatable-cell-template>
            <input type="checkbox" class="form-check-input" style="margin-left: 0px;" [checked]="row.isMedicalCardActive" [disabled]="row.isMedicalCardActive"
              (change)="toggleMedicalCardStatus(row)">
          </ng-template>
        </ngx-datatable-column>

      </ngx-datatable>
    </div>
  </div>

</div>
<ngx-spinner></ngx-spinner>